import axios from 'axios';

export const sendPreApprovalRequest = (data) => {
  return new Promise((resolve, reject) => {
    let body = { data: data };

    console.log('Sending finance request:', data);

    axios
      .post(
        'https://us-central1-fasttrack-client.cloudfunctions.net/api/financerequest',
        // 'http://localhost:5001/fasttrack-client/us-central1/api/financerequest',
        body,
      )
      // .post('https://www.suzuki-fasttrack.co.za/financerequest', body)
      // .post('http://localhost:5000/financerequest', body)
      .then((res) => {
        console.log('Finance request response: ', res.data);
        resolve(res.data);
      })
      .catch((e) => {
        // Check if the error has a response property
        if (e.response) {
          // Reject with the response data if available
          reject(e.response.data);
        } else {
          // Reject with the entire error object if response data is not available
          reject(e);
        }
      });
  });
};

export const getOccupations = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `https://us-central1-fasttrack-client.cloudfunctions.net/api/occupations`,
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => reject(e));
  });
};

export const getDealers = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: 'https://us-central1-fasttrack-client.cloudfunctions.net/api/dealers',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        resolve(res);
      })
      .catch((e) => reject(e));
  });
};
